






























































import { Vue, Component } from 'vue-property-decorator'
import PStorage, { AUTOLOCK_TIMEOUT } from '@/util/PStorage'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'

/* eslint-disable indent */
@Component({
    name: 'security-panel',
    components: { SettingsHeader, SettingsSection, SettingsRow }
})
/* eslint-enable indent */
export default class SecurityPanel extends Vue {
    autolockTimeout: number = PStorage.get(AUTOLOCK_TIMEOUT) || 10

    setAutolockTimeout(value: number): void {
        PStorage.set(AUTOLOCK_TIMEOUT, value)
        this.autolockTimeout = value
    }
}
